import { cmsApi } from "@/api";
import type { IAdvert } from "./types";

export const getAdverts = async (locale: string) =>
  await cmsApi
    .get<{
      data: IAdvert[];
    }>(`/adverts?locale=${locale}&pagination[limit]=1000&populate=*`)
    .then(({ data }) => data.data);
